import fetch from 'isomorphic-fetch';

// eslint-disable-next-line import/prefer-default-export
export const fetchCamEmbedDetails = async (cameraId) => {
  const response = await fetch(`https://embed.${process.env.NODE_ENV}.surfline.com/cam-details/${cameraId}.json`);
  return response.json();
};
